module.exports = __webpack_public_path__ + "static/media/sleep-basics@2x.2310e251.png";